import React, { useState } from 'react';

const SlotGroup = ({ node, renderSlot }) => {
  const [expanded, setExpanded] = useState(true);
  return (
    <section className="jianying-business-group">
      <button type="button" className="jianying-business-group__header" onClick={() => setExpanded((value) => !value)} aria-expanded={expanded}>
        <i className={`bi bi-chevron-${expanded ? 'down' : 'right'}`} />
        <i className="bi bi-collection-play" />
        <span><strong>{node.group.name}</strong><small>业务展示组</small></span>
      </button>
      {expanded ? (
        <div className="jianying-business-group__children">
          {node.children.map((child) => child.type === 'group'
            ? <SlotGroup key={child.key} node={child} renderSlot={renderSlot} />
            : renderSlot(child.slot))}
        </div>
      ) : null}
    </section>
  );
};

const JianyingSlotGroupTree = ({ renderSlot, sections = [] }) => {
  const groups = sections.filter((node) => node.type === 'group');
  const rootSlots = sections.filter((node) => node.type === 'slot');
  return (
    <div className="jianying-slot-group-tree">
      {groups.map((node) => <SlotGroup key={node.key} node={node} renderSlot={renderSlot} />)}
      {rootSlots.length ? (
        <section className="jianying-business-group is-ungrouped">
          <header className="jianying-business-group__header">
            <i className="bi bi-circle" />
            <span><strong>未分组素材</strong><small>直接属于模板</small></span>
          </header>
          <div className="jianying-business-group__children">
            {rootSlots.map((node) => renderSlot(node.slot))}
          </div>
        </section>
      ) : null}
    </div>
  );
};

export default JianyingSlotGroupTree;
